import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { allArticles } from '@/mocks/content';

export default function ArticleDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const article = allArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-20 text-center">
            <i className="ri-error-warning-line text-5xl text-foreground-300 mb-4 block"></i>
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-2">文章未找到</h1>
            <p className="text-foreground-500 mb-6">该文章不存在或已被删除</p>
            <Link to="/article" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-left-line"></i>
              返回文章列表
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const detailImages: Record<number, string> = {
    1: 'https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20showing%20video%20app%20interface%2C%20minimalist%20tech%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20soft%20shadows%2C%20neutral%20background&width=1200&height=600&seq=art-detail-01&orientation=landscape',
    2: 'https://readdy.ai/api/search-image?query=Premium%20membership%20concept%20with%20elegant%20gold%20accents%2C%20luxury%20lifestyle%20aesthetic%2C%20dark%20background%20with%20warm%20highlights%2C%20sophisticated%20visual%2C%20clean%20composition&width=1200&height=600&seq=art-detail-02&orientation=landscape',
    3: 'https://readdy.ai/api/search-image?query=Film%20reel%20and%20cinema%20concept%2C%20artistic%20movie%20themed%20still%20life%2C%20warm%20vintage%20tones%2C%20creative%20composition%2C%20soft%20dramatic%20lighting%2C%20cinematography%20aesthetic&width=1200&height=600&seq=art-detail-03&orientation=landscape',
    4: 'https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20clean%20modern%20design%2C%20professional%20tech%20aesthetic%2C%20warm%20tones%2C%20minimalist%20style&width=1200&height=600&seq=art-detail-04&orientation=landscape',
    5: 'https://readdy.ai/api/search-image?query=Modern%20TV%20screen%20showing%20video%20settings%20interface%2C%20clean%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20minimalist%20living%20room%20setup%2C%20professional%20product%20photography&width=1200&height=600&seq=art-detail-05&orientation=landscape',
    6: 'https://readdy.ai/api/search-image?query=Community%20guidelines%20concept%20illustration%2C%20warm%20harmonious%20colors%2C%20abstract%20people%20figures%2C%20clean%20modern%20design%2C%20friendly%20atmosphere%2C%20soft%20gradients&width=1200&height=600&seq=art-detail-06&orientation=landscape',
  };
  const detailImage = detailImages[article.id] || detailImages[1];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            author: {
              '@type': 'Organization',
              name: article.author,
            },
            datePublished: article.date,
            url: `https://www.91zaixianshipin.com/article/${article.slug}`,
            publisher: {
              '@type': 'Organization',
              name: '91在线视频',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.91zaixianshipin.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '资讯动态',
                item: 'https://www.91zaixianshipin.com/article',
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: article.title,
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main className="pt-16">
        <article>
          <div className="bg-background-100 py-10 md:py-14">
            <div className="max-w-[900px] mx-auto px-4 md:px-8">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap">
                <Link to="/" className="hover:text-accent-600 transition-colors whitespace-nowrap">首页</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <Link to="/article" className="hover:text-accent-600 transition-colors whitespace-nowrap">资讯动态</Link>
                <i className="ri-arrow-right-s-line text-xs"></i>
                <span className="text-foreground-700 font-medium whitespace-nowrap line-clamp-1">{article.title}</span>
              </nav>

              <div className="mb-6">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  {article.category}
                </span>
                <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
                  {article.title}
                </h1>
                <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <div className="flex items-center gap-2 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 bg-background-100 text-foreground-600 text-xs rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="max-w-[900px] mx-auto px-4 md:px-8 py-8 md:py-12">
            <div className="rounded-2xl overflow-hidden mb-10">
              <img
                src={detailImage}
                alt={article.title}
                className="w-full aspect-[2/1] object-cover"
              />
            </div>

            <div
              className="prose prose-lg max-w-none font-body text-foreground-700 leading-relaxed
                [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-foreground-900 [&_h2]:mt-10 [&_h2]:mb-4
                [&_h3]:font-heading [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-foreground-800 [&_h3]:mt-8 [&_h3]:mb-3
                [&_p]:mb-4 [&_p]:leading-relaxed
                [&_strong]:text-foreground-900 [&_strong]:font-semibold
                [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-4 [&_ul]:space-y-1
                [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-4 [&_ol]:space-y-1
                [&_li]:mb-1"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <div className="mt-12 pt-8 border-t border-background-200/70">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <Link
                  to="/article"
                  className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 font-medium text-sm transition-colors"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回文章列表
                </Link>
                <div className="flex items-center gap-3">
                  <span className="text-sm text-foreground-500">分享到：</span>
                  <button className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="分享到微博">
                    <i className="ri-weibo-line"></i>
                  </button>
                  <button className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="分享到微信">
                    <i className="ri-wechat-line"></i>
                  </button>
                  <button className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-accent-100 hover:text-accent-600 transition-colors cursor-pointer" aria-label="复制链接">
                    <i className="ri-link"></i>
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-background-100 rounded-2xl">
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">相关文章</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {allArticles
                  .filter((a) => a.id !== article.id)
                  .slice(0, 2)
                  .map((related) => (
                    <Link
                      key={related.id}
                      to={`/article/${related.slug}`}
                      className="p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
                    >
                      <span className="text-xs text-accent-600 font-medium">{related.category}</span>
                      <h4 className="font-heading text-sm font-bold text-foreground-900 mt-1 mb-1 line-clamp-2 hover:text-primary-600 transition-colors">
                        {related.title}
                      </h4>
                      <span className="text-xs text-foreground-400">{related.date}</span>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}